import map from 'lodash/map';

export function extractNextTripData({ next_campaigns = [] }) {
  const sorted = next_campaigns.sort((a, b) => {
    return b.release_date - a.release_date;
  });

  return map(sorted, (item) => ({
    city: item.market_name,
    date: item.release_date,
    networkCode: item.network_code
  }));
}
